module.exports = __webpack_public_path__ + "img/preventative-dental-care.f181842f.jpg";